/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

const styles = {
  paragraphPadding: css`
    padding-bottom: 24px;
  `,
  titleAndContentPadding: css`
    padding-bottom: 8px;
  `,
};
const NeedMoreFlexibilityContent = () => (
  <React.Fragment>
    <Typography variant="h2semibold">{_t('Need more flexibility?')}</Typography>
    <Typography css={styles.titleAndContentPadding} variant="h2semibold">
      {_t('Enroll in a non-credit degree course and upgrade to for-credit later')}
    </Typography>

    <Typography2 component="p" css={styles.paragraphPadding}>
      {_t(
        'Start by taking non-credit degree courses and completing them at your own pace. Then upgrade to for-credit when the course is being offered for-credit by the university, and your progress will carry over, and the credit will count towards your degree.'
      )}
    </Typography2>

    <Typography2 component="p">
      {_t(
        'Discover non-credit courses in this page and enroll directly on Coursera. Find out when the course is being offered for-credit by checking out the program’s curriculum.'
      )}
    </Typography2>
  </React.Fragment>
);

export default NeedMoreFlexibilityContent;
